<template>
    <page-card-wrapper>
      <page-card>
        <div v-if="errorMessage" class="error-msg">
          <span>{{errorMessage}}</span>
        </div>
        <page-title>Welcome to ReadTheory!<br>Let's get started!</page-title>
        <page-subtitle>Signup as a...</page-subtitle>
        <div class="role-buttons-group">
            <Role-Button src="/assets/app/signup/icon-student-role.svg" :onClick="onClick" role="Student"></Role-Button>
            <Role-Button src="/assets/app/signup/icon-teacher-role.svg" :onClick="onClick" role="Teacher"></Role-Button>
            <Role-Button src="/assets/app/signup/icon-parent-role.svg" :onClick="onClick" role="Parent"></Role-Button>
            <Role-Button src="/assets/app/signup/icon-school-leader-role.svg" :onClick="onClick" role="School Leader"></Role-Button>
        </div>
    </page-card>
    </page-card-wrapper>
</template>

<script>

  import PageCard from '../common/PageCard.vue'
  import PageTitle from '../common/PageTitle.vue'
  import PageSubtitle from '../common/PageSubtitle.vue'
  import RoleButton from './components/RoleButton.vue'
  import {model} from './sign_up_model'
  import _ from 'lodash'
  import PageCardWrapper from '../common/PageCardWrapper.vue'
  import Toast from '../../../common/Toast';
  import {enableFooterStyleForSignup} from './sign_up_utils';
  import RTGoogleAnalytics from '../../../common/RTGoogleAnalytics';
  import RTGoogleAnalyticsManager from '../../../common/RTGoogleAnalyticsManager';
  import Utils from 'common/Utils';

  export default {
    data() {
      return {
        model,
        errorMessage: null,
      }
    },
    components: {
      PageCardWrapper,
      PageCard,
      PageTitle,
      PageSubtitle,
      RoleButton,
    },
    mounted() {
      enableFooterStyleForSignup(true);
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('message')) {
        this.errorMessage = urlParams.get('message');
      }
    },
    methods: {
      onClick(role) {
        // Toast container is in App.vue
        // Toast.info('Toast Info', 10000);
        // Toast.success('Toast Success', 2000);
        // Toast.warning('Toast Warning', 3000);
        // Toast.error('Toast Error', 4000);
        RTGoogleAnalytics.sendEvent('signup_role_selected', role);
        RTGoogleAnalyticsManager.sendGA4Event(role, 'signup_role_selected');
        if (role === 'School Leader') {
          window.location.replace('/get-in-touch-students/?_utm_campaign=institutions');
          return;
        }
        this.model.role = _.toLower(role);
        this.model.ref = localStorage.getItem('ref');
        this.$emit('stepCompleted', {role, step: 'create-account', abtest: Utils.getABTestParam() });
      }
    }
  }

</script>

<style scoped lang="scss">

    @media screen and ( max-width: 900px ) {
        .role-buttons-group {
            margin: 3rem 0;
        }
    }
    @media screen and ( max-width: 700px ) {
        .error-msg {
          max-width: 100%;
        }

        .role-buttons-group {
            margin: 0;
            flex-flow: column;
        }

    }

    .error-msg {
      background-color: #fde7e7;
      padding: 1rem;
      border-radius: 15px;
      border: 1px solid #c30000;
      position: relative;
      top: -50px;
      max-width: 80%;
      margin: 0 auto;
      color: #c30000;
    }

    .role-buttons-group {
        margin: 1.2rem 3rem;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: space-around;
        justify-items: center;
    }

</style>
